// 定义Props类型
interface CardProps {
  children?: React.ReactNode
}

export function Card({ children }: CardProps) {
  return <div className='border-rd-12px bg-#fff p-24px h-100%'>{children}</div>
}
